<template>
  <v-container class="px-0 pb-10">
    <div class="carrinho-bar">
      <span :class="['etapa', info.status=='C'? 'etp0': 'etp1']">
        <v-icon :color="info.status=='C'?colors[0]:colors[1]" size="13px">fa-circle</v-icon>
        <p class="text-circle">
          Inclusao <br />
          dos lotes
        </p>
        <!-- <legend v-show="showLote" class="legend-status pie">2 lotes</legend> -->
      </span>
      <div class="bar"  v-if="info.em_validacao_status || info.em_validacao_status==0"></div>
      <span :class="['status','etapa', `etp${info.em_validacao_status}`]" v-if="info.em_validacao_status || info.em_validacao_status==0">
        <p>Em validação</p>
        <!-- <legend class="legend-status st" v-if="info.em_validacao">{{info.em_validacao}} lotes</legend> -->
      </span>
      <div class="bar" v-if="info.validados_status || info.validados_status==0"></div>
      <span  :class="['etapa', `etp${info.validados_status}`]" v-if="info.validados_status || info.validados_status==0">
        <v-icon :color="colors[info.validados_status]" size="13px">fa-circle</v-icon>
        <p class="text-circle pf">Lotes validados</p>
        <legend class="legend-status pie" v-if="info.validados">{{info.validados}} lotes</legend>
      </span>
      <div class="bar"  v-if="info.config && info.config.FAT_ENVIO_OPERADORA && (info.em_transmissao_status || info.em_transmissao_status==0)"></div>
      <span :class="['status','etapa', `etp${info.em_transmissao_status}`]" v-if="info.config && info.config.FAT_ENVIO_OPERADORA && (info.em_transmissao_status || info.em_transmissao_status==0)">
        <p>Em trasmissão</p>
        <!-- <legend class="legend-status st" v-if="info.em_transmissao">{{info.em_transmissao}} lotes</legend> -->
      </span>
      <div class="bar" v-if="info.config && info.config.FAT_ENVIO_OPERADORA && (info.transmitido_status || info.transmitido_status==0)"></div>
      <span  :class="['etapa', `etp${info.transmitido_status}`]" v-if="info.config && info.config.FAT_ENVIO_OPERADORA && (info.transmitido_status || info.transmitido_status==0)">
        <v-icon :color="colors[info.transmitido_status]" size="13px">fa-circle</v-icon>
        <p class="text-circle pf">Lotes transmitidos</p>
        <legend class="legend-status pie" v-if="info.transmitido">{{info.transmitido}} lotes</legend>
      </span>

      <div class="bar"  v-if="info.situacao_protocolo_status || info.situacao_protocolo_status==0"></div>
      <span :class="['status','etapa', `etp${info.situacao_protocolo_status}`]" v-if="info.situacao_protocolo_status || info.situacao_protocolo_status==0">
        <p>Situação protocolo</p>
        <!-- <legend class="legend-status st" v-if="info.situacao_protocolo">{{info.situacao_protocolo}} lotes</legend> -->
      </span>
      <div class="bar" v-if="info.analisados_operadora_status || info.analisados_operadora_status==0"></div>
      <span  :class="['etapa', `etp${info.analisados_operadora_status}`]" v-if="info.analisados_operadora_status || info.analisados_operadora_status==0">
        <v-icon :color="colors[info.analisados_operadora_status]" size="13px">fa-circle</v-icon>
        <p class="text-circle pf">Lotes analisados <br />
          pela operadora</p>
        <legend class="legend-status pie" v-if="info.analisados_operadora">{{info.analisados_operadora}} lotes</legend>
      </span>

      <div class="bar"  v-if="info.capa_lote_status || info.capa_lote_status==0"></div>
      <span :class="['status','etapa', `etp${info.capa_lote_status}`]" v-if="info.capa_lote_status || info.capa_lote_status==0">
        <p>{{!!info.config && info.config.FAT_CAPA_LOTE_OBRIGATORIO? 'Capa do lote' : 'Finalizados'}}</p>
        <!-- <legend class="legend-status st" v-if="info.capa_lote">{{info.capa_lote}} lotes</legend> -->
      </span>
      <div class="bar"></div>
      <span :class="['etapa', info.status=='F'? 'etp1': 'etp0']">
        <b class="dt-encerramento" v-if="info.dt_encerramento!='0001-01-01T00:00:00'">{{info.dt_encerramento}}</b>
        <v-icon :color="info.status=='F'? colors[1] : colors[0]" size="13px">fa-circle</v-icon>
        <p class="text-circle lf">
          Cronograma <br />
          Concluido 
        </p>
      </span>
    </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      colors: ['#777272', '#CFD403', '#D0021B', '#fdf458'],
      showLote: false,
    };
  },
  props:{
    info: Object,
    parameter: Object
  },
};

</script>

<style lang="scss" scoped>
.carrinho-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin: 10px 0;
  .etapa {
    color: #dadada;
    border: 1px solid #dadada;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    line-height: 27px;
    text-align: center;
  }
  .status {
    font-size: 10px;
    font-weight: 500;
    background-color: #94999C;
    border-radius: 9px;
    width: 90px;
    height: 20px;
    line-height: 16px;
    padding: 2px;
    text-align: center;
  }
  .bar {
    flex: 1;
    height: 2px;
    background-color: #dadada;
  }
  .text-circle {
    color: #94999C;
    font-size: 13px;
    line-height: 16px;
    position: absolute;
    margin-top: 8px;
    margin-left: -10px;
  }
  .text-circle.lf {
    margin-left: -16px;
  }
  .text-circle.pf {
    margin-left: -26px;
  }
  .legend-status {
    font-family: sans-serif;
    color: #94999C;
    font-size: 10px;
    line-height: 17px;
    position: absolute;
  }
  .legend-status.pie {
    margin-top: -48px;
    margin-left: 0px;
  }
  .legend-status.st {
    margin-top: -58px;
    margin-left: 30px;
  }
    .status.etapa.etp0 {
        background-color: #94999C;
        color: #FFFFFF;
      }
    .status.etapa.etp1 {
        background-color: #CFD403;
        color: #4a4a4a;
      }
      .status.etapa.etp2 {
        background-color: #D0021B;
        color: #FFFFFF;
      }

      .status.etapa.etp3 {
        background-color: #fdf458;
        color: #4a4a4a;
      }
  .etapa.etp0 {
    border-color: #94999C;
  }
  .etapa.etp1 {
    border-color: #CFD403;
  }
  .etapa.etp2 {
    border-color: #D0021B;
  }
  .etapa.etp3 {
    border-color: #fdf458;
  }
  .dt-encerramento {
    font-size: 11px;
    position: absolute;
    top: 265px;
    right: 65px;
    color: #a8acaf;
  }
}

</style>

